import React, { useEffect, useState } from 'react'
import { Redirect, withRouter, RouteComponentProps } from 'react-router-dom'

//================ Components ===============================

import LinearIndeterminate from 'components/shared/LinearProgress'
import { StyledBody, StyledModal } from 'pages/DocError/DocError'
import { StyledLogoWrapper } from 'components/shared/LockedModal'
import DiligentErrorIcon from 'assets/icons/DiligentErrorIcon'
import { Box, Button, makeStyles } from '@material-ui/core'
import i18n from 'common/util/internationalization'
import { ColorButtonHover, ColorEastBay } from 'assets/styles/variables'
import {
    getLocalStorageItem,
    getSessionStorageItem,
    removeLocalStorageItem,
    removeSessionStorageItem
} from 'businesslayer/minutesLocalStore'
const useStyles = makeStyles(() => ({
    customButton: {
        backgroundColor: `${ColorEastBay}`,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '20px',
        height: '40px',
        borderRadius: '2px',
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: `${ColorButtonHover}`
        },
        color: '#FFFFFF'
    }
}))

const customStyles = {
    overlay: {
        backgroundColor: '#FFFFFF',
        zIndex: 1000
    }
}

const sessionExpiredTextTitle = {
    fontWeight: 600,
    fontSize: '28px',
    lineHeight: '32px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center'
}

const sessionExpiredText = {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '20px'
}

type NotFoundProps = RouteComponentProps & {
    hasCommittee?: boolean
}

function NotFound(props: NotFoundProps) {
    const { hasCommittee = true } = props

    const [navigatingOut, setNavigatingOut] = useState(false)
    const isReloaded = sessionStorage.getItem('reloaded') === 'false'
    const classes = useStyles()
    const [redirectTarget, setRedirectTarget] = useState('/')
    const [buttonText, setButtonText] = useState(i18n.t('NOT_FOUND_LINK'))
    const [isActionDashboard, setIsActionDashboard] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const checkIfDeeplinkActionError = (): boolean => {
        const isDeeplinkActionError = getSessionStorageItem('isDeeplinkActionError') === 'true'
        const isDeeplinkActionErrorLocal = getLocalStorageItem('isDeeplinkActionError') === 'true'
        return isDeeplinkActionError || isDeeplinkActionErrorLocal
    }
    useEffect(() => {
        const currentUrl = new URL(window.location.href)
        if (currentUrl.search && !currentUrl.search?.includes('bookId')) {
            currentUrl.search = ''
            window.history.replaceState(null, '', currentUrl.toString())
        }
    }, [])
    useEffect(
        () => {
            // Skip deeplink check if no committee access
            if (hasCommittee && !isActionDashboard) {
                const isFromDeeplink = checkIfDeeplinkActionError()

                if (isFromDeeplink) {
                    setRedirectTarget('/actionDashboard')
                    setButtonText(i18n.t('NOT_FOUND_ACTION_LINK'))
                    setIsActionDashboard(true)
                    setErrorMessage(i18n.t('NOT_FOUND_DEEPLINK_ACTION_MESSAGE'))
                }
            }
            if (isReloaded) {
                sessionStorage.setItem('reloaded', 'true')
                window.location.reload()
            }
        },
        //eslint-disable-next-line react-hooks/exhaustive-deps
        [isReloaded, isActionDashboard, hasCommittee] //location
    )
    if (navigatingOut) {
        removeSessionStorageItem('isDeeplinkActionError')
        removeLocalStorageItem('isDeeplinkActionError')
        return (
            <Redirect
                to={{
                    pathname: redirectTarget,
                    state: {}
                }}
            />
        )
    }

    if (isReloaded) {
        return <LinearIndeterminate loading={true} />
    }
    return (
        <StyledModal isOpen={true} style={customStyles}>
            <StyledLogoWrapper>
                <DiligentErrorIcon />
            </StyledLogoWrapper>
            <StyledBody>
                <Box style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {hasCommittee && (
                        <div style={sessionExpiredTextTitle}>{i18n.t('NOT_FOUND')}</div>
                    )}
                    <div style={sessionExpiredText}>
                        {!hasCommittee ? (
                            <>
                                <p style={{ textAlign: 'center' }}>
                                    {i18n.t('NO_COMMITTEE_ASSIGNED')}
                                </p>
                                <p style={{ textAlign: 'center' }}>
                                    {i18n.t('NO_COMMITTEE_ASSIGNED_SUGGETION')}
                                </p>
                            </>
                        ) : errorMessage ? (
                            <p style={{ textAlign: 'center' }}>{errorMessage}</p>
                        ) : (
                            <>
                                <p style={{ textAlign: 'center' }}>
                                    {i18n.t('NOT_FOUND_PAGE_MESSAGE')}
                                </p>
                                <p style={{ textAlign: 'center' }}>
                                    {i18n.t('NOT_FOUND_PAGE_MESSAGE_SUGGESTION')}
                                </p>
                            </>
                        )}
                    </div>
                </Box>
            </StyledBody>
            {hasCommittee && (
                <Box display="flex" justifyContent="center">
                    <Button className={classes.customButton} onClick={() => setNavigatingOut(true)}>
                        {buttonText}
                    </Button>
                </Box>
            )}
        </StyledModal>
    )
}
//#endregion

export default withRouter(NotFound)
